import { trimURLPath } from "../utils/trimURLPath";
import { getLocationPathName } from "../utils";
import { UserProfileProps } from "@welldigital/ui-common";

const privatePaths = new Set([""]);
const pathsWithNoLoginButton = new Set(["sign-in", "sign-in/complete"]);

export const getUserProfileProps = (): Partial<UserProfileProps> => {
  const currentPath = trimURLPath(getLocationPathName());
  return {
    // authentication is required for any path in array
    isAuthenticationRequired: privatePaths.has(currentPath),
    shouldTriggerAuthentication: true,
    // should show login link when authentication is not required everywhere but not on these pages
    shouldShowLoginWhenNotIsAuthenticationRequired:
      !pathsWithNoLoginButton.has(currentPath),
  };
};
